export default __webpack_public_path__ + "static/media/272.01f6bd4c.jpg";